import { render, staticRenderFns } from "./Bindings.vue?vue&type=template&id=f12faf08"
import script from "./Bindings.vue?vue&type=script&lang=js"
export * from "./Bindings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports